/* eslint-disable */

import * as React from "react";
import { Button } from "@material-ui/core";

// type ChangeEvent<HTMLInputElement> = React.ChangeEvent<HTMLTextAreaElement>;
type EventListener<EventType> = (event: EventType) => void;
const getImage = (name: string): string => {
  return require(`../../images/${name}`);
};

const browseImg = getImage("Browse.svg");

export interface BrowseFileButtonProps {
  text: string;
  onChange: any;
  id?: string;
  disabled?: boolean;
  styles?: React.CSSProperties;
  testId?: string;
  startIcon?: React.ReactNode;
  dontAllowMultipleSelect?:boolean;
  uploadBtnRef?: any;
}

export const BrowseFileButton: React.FunctionComponent<BrowseFileButtonProps> = (
  props
) => {
  const { onChange, text, testId, id, disabled, styles, startIcon,dontAllowMultipleSelect,uploadBtnRef, ...remainingProps } = props;
  return (
    <div>
      <input
        //   accept="image/*"
        style={{
          display: "none",
        }}
        id={id || text}
        multiple={!dontAllowMultipleSelect}
        type="file"
        onChange={onChange}
        onClick={(event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
          const element = event.target as HTMLInputElement;
          element.value = "";
        }}
        data-testid={testId}
        disabled={disabled}
      />
      <label htmlFor={id || text}>
        <Button
          variant="contained"
          color="primary"
          component="span"
          startIcon={startIcon ? startIcon : <img src={browseImg} alt="browse" />}
          disabled={disabled}
          {...remainingProps}
          style={styles ? {...styles} : {}}
          ref={uploadBtnRef}
          onKeyDown={(e: any) => {
            var input = document.getElementById(id || text);
            if (input) {
              if (e.keyCode === 13) {
                // Cancel the default action, if needed
                e.preventDefault();
                // Trigger the button element with a click
                input.click();
              }
            }
          }}
        >
          {text}
        </Button>
      </label>{" "}
    </div>
  );
};
